import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useMemo } from 'react';

import {
  Box,
  Flex,
  Modal,
  Spinner,
  ModalContext,
  PaginationContext,
  PaginationLoadMore,
} from 'dash-ui';

import { useGetAlertItemsQuery } from 'gql/generated.graphql';
import PropertyCard from 'containers/properties/PropertyCard/PropertyCard';

import { GridBox } from './PropertiesAlertsModal.styles';

const PropertiesAlertsModal = () => {
  const { t } = useTranslation(['common', 'pages']);
  const {
    isOpenCurrent,
    toggleModal,
    payload = {},
    setPayload,
  } = useContext(ModalContext);
  const isOpen = isOpenCurrent['PropertiesAlertsModal'];

  const { setTotal, state, resetPagination } = useContext(PaginationContext);

  const variables = useMemo(
    () => ({
      pagination: {
        limit: state.perPage,
      },
      filter: {
        isNew: true,
        range: payload.range,
      },
    }),
    [state, payload]
  );

  const { data, loading, fetchMore } = useGetAlertItemsQuery({
    variables: variables,
    fetchPolicy: 'network-only',
  });

  const { properties, totalCount } = useMemo(
    () => ({
      properties: data?.getAlertItems.collection || [],
      totalCount: data?.getAlertItems.totalCount || 0,
    }),
    [data]
  );

  useEffect(() => {
    // FIXME: re-creating context functions everytime state change. Use useCallback
    setTotal(totalCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCount]);

  const closeModal = () => {
    toggleModal(false, 'PropertiesAlertsModal');
    setPayload({});
    resetPagination();
  };

  return (
    <Modal
      closeIcon
      w={[343, 809, 825, 1000]}
      isOpen={isOpen}
      onRequestClose={closeModal}
      title={
        t(
          'pages:dashboardPage.propertyAlertsWidget.propertiesAlertsModalTitle'
        ) || ''
      }
    >
      {loading && (
        <Flex alignItems="center" justifyContent="center" w="100%">
          <Spinner size={24} />
        </Flex>
      )}
      <Box pt={4}>
        <GridBox>
          {properties.map((item: any) => (
            <PropertyCard key={item._id} property={item.property} smallScale />
          ))}
        </GridBox>
        <Flex mt={[4, 6, 6, 6]} w="100%">
          <PaginationLoadMore
            w="100%"
            fetchMoreProps={{
              fetchMore,
              variables,
              queryName: 'getAlertItems',
            }}
          >
            {t('common:labels:showMore')}
          </PaginationLoadMore>
        </Flex>
      </Box>
    </Modal>
  );
};

export default PropertiesAlertsModal;
